<nav mat-tab-nav-bar class="ppp-shell__nav" lohiPageTitle="Preferred Partner">
  <a
    mat-tab-link
    [routerLink]="['./']"
    [routerLinkActiveOptions]="{ exact: true }"
    routerLinkActive
    #overviewLink="routerLinkActive"
    [active]="overviewLink.isActive"
  >
    Overview
  </a>
  <a
    mat-tab-link
    [routerLink]="['./drivers']"
    routerLinkActive
    #driversLink="routerLinkActive"
    [active]="driversLink.isActive"
  >
    Drivers
  </a>
  <a
    mat-tab-link
    [routerLink]="['./bonuses']"
    routerLinkActive
    #bonusesLink="routerLinkActive"
    [active]="bonusesLink.isActive"
  >
    Load bonuses
  </a>
  <a
    mat-tab-link
    [routerLink]="['./rules']"
    routerLinkActive
    #rulesLink="routerLinkActive"
    [active]="rulesLink.isActive"
  >
    Program rules
  </a>
</nav>
<router-outlet></router-outlet>
